import { useEffect, useState, useContext } from "react";
import { useDropzone } from "react-dropzone";
import img from "../../../frontend/assets/img/icons/cloud-upload.svg";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { petitions } from "../../../api/calls";
import { DataContext } from "../../../context/DataContext";
import { toast } from "sonner";
import feather from "feather-icons";
import {useNavigate,NavLink } from 'react-router-dom';
import customStyles from "../../../frontend/styles/select";
import customStyles_v2 from "../../../frontend/styles/select_v2";

export default function CrearProducto() {
  const { session, idEmpresa } = useContext(DataContext);
  const [categoria, setCategoria] = useState([]);
  const [medida, setMedida] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [area, setArea] = useState([]);
  const [local, setLocal] = useState([]);
  const [TPServicio, setTPServicio] = useState([])

  const navigate = useNavigate();

  //COMPLEMENTO
  const [file, setFile] = useState(null);
  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({
      accept: "image/*",
      multiple: false,
      onDrop: (acceptedFiles) => {
        setFile(acceptedFiles[0]);
      },
    });
  const handleRemove = () => {
    setFile(null);
  };

  //FORMULARIO COMPLETO
  const form1 = useForm({
    defaultValues: {
        "tipo": "P",
        "kardex": true,
        "pcompra": 0.0,
        "pventa": 0.0,
        "stock": 0.0,
        "cicloConsumo": 0.0
    }
  });

  //CATEGORIA
  useEffect(() => {
    const fetchData = async () => {
      const response = await petitions.getCategoria(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idCategoria,
          label: e.nombre,
        }));
        setCategoria(array);
        array.length > 0 && form1.setValue("idCategoria", array[0].value, { shouldValidate: true });
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };
    fetchData();
  }, [form1,session, idEmpresa]);

  //MEDIDA
  useEffect(() => {
    const fetchMedida = async () => {
      const response = await petitions.getMedida(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMedida,
          label: `${e.idMedida} - ${e.descripcion}`,
        }));

        setMedida(array);

        if (array.length > 0) {
          form1.setValue("idMedida", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMedida();
  }, [form1, idEmpresa, session]);


  //AREA
  useEffect(() => {
    const fetchAreas = async () => {
      const obj = session();
      const response = await petitions.getAreas(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idArea,
          label: e.nomArea,
        }));

        setArea(array);

        if (array.length > 0) {
          form1.setValue("idArea", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAreas();
  }, [form1, idEmpresa, session]);

  //LOCAL
  useEffect(() => {
    const fetchLocal = async () => {
      const obj = session();
      const response = await petitions.getLocal(idEmpresa(), obj.token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idLocal,
          label: e.nomLocal,
        }));

        setLocal(array);

        if (array.length > 0) {
          form1.setValue("idLocal", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchLocal();
  }, [idEmpresa, session, form1]);


  //MARCA Y MODELO
  useEffect(() => {
    const fetchMarca = async () => {
      const response = await petitions.getMarca(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMarca,
          label: e.descripcion,
        }));

        setMarca(array);

        if (array.length > 0) {
          form1.setValue("idMarca", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMarca();
  }, [idEmpresa, session, form1]);


  useEffect(() => {
    const fetchModeloMarca = async () => {
      const response = await petitions.getModeloMarca(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setModelo(array);

        if (array.length > 0) {
          form1.setValue("idModelo", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchModeloMarca();
  }, [idEmpresa, session, form1]);


  useEffect(() => {
    const fetchTPServicio = async () => {
      const response = await petitions.getTPServicio(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idTPservicio,
          label: e.descripcion,
        }));

        setTPServicio(array);

        if (array.length > 0) {
          form1.setValue("idTPServicio", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPServicio();
  }, [idEmpresa, session, form1]);

  useEffect(() => {
    feather.replace();
  }, []);

  const sendProducto = form1.handleSubmit(async (data) => {
    data.kardex = data.kardex ? 'S' : 'N'    
    const formData = new FormData();
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
          data[key] != "" && formData.append(key, data[key]);
      }
    }
    
    // Añadir archivo
    file && formData.append('postFoto', file, file.name);
    
    const response = await petitions.insertPServicio(idEmpresa(),session().token, formData)
    if (response.status === "success") {
      if (response.data) {
        setFile(null)
        toast.success('Producto registrado correctamente', {
          description: '¿Deseariá ir al listado de productos?',
          action: {
            label: 'Ir',
            onClick: () => {navigate('/main/VerProducto', { replace: true })}
          },
        })
        form1.reset()
      }
      else{
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const discard = () => {
    toast('¿Estas seguro(a) que deseas desechar los cambios?', {
      action: {
        label: 'Desechar',
        onClick: () => form1.reset()
      },
    })
  }

  return (
    <>
      <form className="mb-9" onSubmit={sendProducto}>
        <div className="row g-3 flex-between-end mb-5">
          <div className="col-auto">
            <h2 className="mb-2">Añadir un producto / Servicio</h2>
            <h5 className="text-body-tertiary fw-semibold">
              Complete los datos de tu producto o servicio
            </h5>
          </div>
          <div className="col-auto">
            <button
              className="btn btn-phoenix-danger me-2 mb-2 mb-sm-0 rounded-4"
              type="button"
              onClick={()=>{discard()}}
            >
              <span className="far fa-trash-alt"></span>
            </button>
            <button className="btn btn-primary mb-2 mb-sm-0 rounded-4" type="submit">
              Registrar producto
            </button>
          </div>
        </div>
        <div className="row g-5">
          <div className="col-12 col-xl-8">
            <div className="mb-6">
              <h4 className="mb-3">Título del producto</h4>
              <input
                className="form-control rounded-4 border-0 shadow-sm"
                type="text"
                placeholder="Escribe el titulo aquí..."
                {...form1.register("nombre", {
                  required: {
                    value: true,
                    message: "Este campo es obligatorio",
                  },
                  maxLength: {
                    value: 250,
                    message: "Nombre demasiado largo",
                  },
                })}
              />
              {form1.formState.errors?.nombre && (
                <div className="mb-3">
                  <code>{form1.formState.errors.nombre.message}</code>
                </div>
              )}
            </div>
            <div className="mb-6">
              <h4 className="mb-3">Descripción del producto</h4>
              <textarea
                className="form-control rounded-4 border-0 shadow-sm"
                id="exampleTextarea"
                placeholder="Escribe la descripción o observación de tu producto aquí..."
                rows="3"
                {...form1.register("obs", {
                  maxLength: {
                    value: 254,
                    message: "Descripción demasiada larga",
                  },
                })}
                defaultValue=""
              />
              {form1.formState.errors?.obs && (
                <code>{form1.formState.errors.obs.message}</code>
              )}
            </div>
            <h4 className="mb-3">Mostrar Imagen</h4>
            <div className="dropzone dropzone-multiple p-0" id="dropzone">
              <div
                {...getRootProps()}
                className={`dz-message rounded-4 ${
                  isDragActive ? "bg-primary text-white" : ""
                } ${isDragReject ? "text-danger" : ""}`}
                data-dz-message="data-dz-message"
              >
                <input {...getInputProps()} name="file" />
                <div className="dz-message-text">
                  <img className="me-2" src={img} width="25" alt="" />
                  Suelta tu foto aquí
                </div>
              </div>

              {file && (
                <div className="dz-preview dz-preview-multiple m-0 d-flex flex-column">
                  <div className="d-flex pb-3 border-bottom border-translucent media px-2">
                    <div className="border p-2 rounded-2 me-2">
                      <img
                        className="rounded-2 dz-image"
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        data-dz-thumbnail="data-dz-thumbnail"
                        style={{ height: "80px", width: "80px" }}
                      />
                    </div>
                    <div className="flex-1 d-flex flex-between-center">
                      <div>
                        <h6 data-dz-name="data-dz-name">{file.name}</h6>
                        <div className="d-flex align-items-center">
                          <p
                            className="mb-0 fs-9 text-body-quaternary lh-1"
                            data-dz-size="data-dz-size"
                          >
                            {Math.round(file.size / 1024)} KB
                          </p>
                        </div>
                        <span
                          className="fs-10 text-danger"
                          data-dz-errormessage="data-dz-errormessage"
                        ></span>
                      </div>
                      <div className="dropdown">
                        <button
                          className="btn btn-link text-body-quaternary btn-sm dropdown-toggle btn-reveal dropdown-caret-none"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span className="fas fa-ellipsis-h"></span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end border border-translucent py-2">
                          <a
                            className="dropdown-item"
                            href="#!"
                            onClick={handleRemove}
                            data-dz-remove="data-dz-remove"
                          >
                            Eliminar archivo
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <br />
            <h4 className="mb-3">Datos</h4>
            <div className="row g-0 border-top border-bottom">
              <div className="col-sm-4">
                <div
                  className="nav flex-sm-column border-bottom border-bottom-sm-0 border-end-sm fs-9 vertical-tab h-100 justify-content-between"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    className="nav-link border-end border-end-sm-0 border-bottom-sm text-center text-sm-start cursor-pointer outline-none d-sm-flex align-items-sm-center active"
                    id="pricingTab"
                    data-bs-toggle="tab"
                    data-bs-target="#pricingTabContent"
                    role="tab"
                    aria-controls="pricingTabContent"
                    aria-selected="true"
                  >
                    {" "}
                    <span
                      className="me-sm-2 fs-4 nav-icons"
                      data-feather="box"
                      style={{ width: "16px", height: "16px" }}
                    ></span>
                    <span className="d-none d-sm-inline">Tipo de ítem</span>
                  </a>
                  <a
                    className="nav-link border-end border-end-sm-0 border-bottom-sm text-center text-sm-start cursor-pointer outline-none d-sm-flex align-items-sm-center"
                    id="restockTab"
                    data-bs-toggle="tab"
                    data-bs-target="#restockTabContent"
                    role="tab"
                    aria-controls="restockTabContent"
                    aria-selected="false"
                  >
                    {" "}
                    <span
                      className="me-sm-2 fs-4 nav-icons"
                      data-feather="tag"
                      style={{ width: "16px", height: "16px" }}
                    ></span>
                    <span className="d-none d-sm-inline">Precios</span>
                  </a>
                  <a
                    className="nav-link border-end border-end-sm-0 border-bottom-sm text-center text-sm-start cursor-pointer outline-none d-sm-flex align-items-sm-center"
                    id="shippingTab"
                    data-bs-toggle="tab"
                    data-bs-target="#shippingTabContent"
                    role="tab"
                    aria-controls="shippingTabContent"
                    aria-selected="false"
                  >
                    {" "}
                    <span
                      className="me-sm-2 fs-4 nav-icons"
                      data-feather="clock"
                      style={{ width: "16px", height: "16px" }}
                    ></span>
                    <span className="d-none d-sm-inline">Garantía</span>
                  </a>
                  <a
                    className="nav-link border-end border-end-sm-0 border-bottom-sm text-center text-sm-start cursor-pointer outline-none d-sm-flex align-items-sm-center"
                    id="productsTab"
                    data-bs-toggle="tab"
                    data-bs-target="#productsTabContent"
                    role="tab"
                    aria-controls="productsTabContent"
                    aria-selected="false"
                  >
                    {" "}
                    <span
                      className="me-sm-2 fs-4 nav-icons"
                      data-feather="codepen"
                      style={{ width: "16px", height: "16px" }}
                    ></span>
                    <span className="d-none d-sm-inline">Stock</span>
                  </a>
                  <a
                    className="nav-link text-center text-sm-start cursor-pointer outline-none d-sm-flex align-items-sm-center"
                    id="advancedTab"
                    data-bs-toggle="tab"
                    data-bs-target="#advancedTabContent"
                    role="tab"
                    aria-controls="advancedTabContent"
                    aria-selected="false"
                  >
                    {" "}
                    <span
                      className="me-sm-2 fs-4 nav-icons"
                      data-feather="lock"
                      style={{ width: "16px", height: "16px" }}
                    ></span>
                    <span className="d-none d-sm-inline">Avanzado</span>
                  </a>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="tab-content py-3 ps-sm-4 h-100">
                  <div
                    className="tab-pane fade show active"
                    id="pricingTabContent"
                    role="tabpanel"
                  >
                    <div className="flex-1">
                      <div className="mb-4">
                        <div className="form-check mb-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="shippingRadio"
                            id="fullfilledBySeller"
                            value="P"
                            {...form1.register("tipo")}
                          />
                          <label
                            className="form-check-label fs-8 text-body d-flex align-items-center"
                            htmlFor="fullfilledBySeller"
                          >
                            Producto
                            <span className="badge badge-phoenix badge-phoenix-info fs-10 ms-2">
                              Por defecto
                            </span>
                          </label>
                        </div>
                        <div className="ps-4">
                          <p className="text-body-secondary fs-9 mb-0">
                            Un bien físico o digital que se vende o distribuye a
                            clientes para satisfacer una necesidad específica.
                          </p>
                        </div>
                      </div>
                      <div className="mb-4">
                        <div className="form-check mb-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="shippingRadio"
                            id="fullfilledByPhoenix"
                            value="S"
                            {...form1.register("tipo")}
                          />
                          <label
                            className="form-check-label fs-8 text-body d-flex align-items-center"
                            htmlFor="fullfilledByPhoenix"
                          >
                            Servicio
                          </label>
                        </div>
                        <div className="ps-4">
                          <p className="text-body-secondary fs-9 mb-0">
                            Una actividad intangible ofrecida por una empresa
                            para atender las necesidades del cliente, como
                            consultoría o soporte técnico.
                          </p>
                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="form-check mb-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="shippingRadio"
                            id="fullfilledByPhoenix"
                            value="Q"
                            {...form1.register("tipo")}
                          />
                          <label
                            className="form-check-label fs-8 text-body d-flex align-items-center"
                            htmlFor="fullfilledByPhoenix"
                          >
                            Paquete
                          </label>
                        </div>
                        <div className="ps-4">
                          <p className="text-body-secondary fs-9 mb-0">
                            Una combinación de productos y/o servicios ofrecidos
                            juntos como una unidad para proporcionar mayor
                            valor.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade h-100"
                    id="restockTabContent"
                    role="tabpanel"
                    aria-labelledby="restockTab"
                  >
                    <div className="d-flex flex-column h-100">
                      <div className="row g-3">
                        <div className="col-12 col-lg-8">
                          <h5 className="mb-2 text-body-highlight">
                            Precio de compra
                          </h5>
                          <input
                            className="form-control rounded-4 border-0 shadow-sm"
                            type="number" 
                            placeholder="S/. 0.0"
                            step="any"
                            {...form1.register("pcompra")}
                          />
                        </div>
                        <div className="col-12 col-lg-8">
                          <h5 className="mb-2 text-body-highlight">
                             Precio de venta
                          </h5>
                          <input
                            className="form-control rounded-4 border-0 shadow-sm"
                            type="number"
                            placeholder="S/. 0.0"
                            step="any"
                            {...form1.register("pventa")}
                          />
                        </div>
                        <p className="fs-9 fw-semibold mb-0">Los precios se registran valor unitario sin incluir <strong className="text-primary fw-bold">(IGV)</strong></p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade h-100"
                    id="shippingTabContent"
                    role="tabpanel"
                    aria-labelledby="shippingTab"
                  >
                    <div className="d-flex flex-column h-100">
                      <h5 className="mb-3 text-body-highlight">
                        Tiempo de garantía
                      </h5>
                      <div className="mb-12">
                        <label className="form-label" htmlFor="exampleTextarea">
                          Descripción
                        </label>
                        <textarea
                          className="form-control rounded-4 border-0 shadow-sm"
                          id="exampleTextarea"
                          placeholder="Credito a 60 días..."
                          rows="3"
                          {...form1.register("tGarantia", {
                            maxLength: {
                              value: 64,
                              message: "Descripción demasiada larga",
                            },
                          })}
                          defaultValue=""
                        />
                        {form1.formState.errors?.tGarantia && (
                          <code>
                            {form1.formState.errors.tGarantia.message}
                          </code>
                        )}
                      </div>
                      <p className="fs-9 fw-semibold mb-0">
                        Recuerda registrar cuidadosamente los datos de tu producto.
                      </p>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="productsTabContent"
                    role="tabpanel"
                    aria-labelledby="productsTab"
                  >
                    <h5 className="mb-3 text-body-highlight">Stock inicial</h5>
                    <div className="row g-3 flex-1 mb-4">
                      <div className="col-sm-10">
                        <input
                          className="form-control rounded-4 border-0 shadow-sm"
                          type="number"
                          placeholder="0.0"
                          step="any"
                          {...form1.register("stock")}
                        />
                      </div>
                      <div className="ps-4">
                        <p className="text-body-secondary fs-9 mb-0">
                          Recuerda que el <b>stock</b> es editable, se puede
                          administrar en otras paginas y es una variable
                          cambiante, es decir se va actualizando de acuerdo a
                          sus ventas y compras.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="advancedTabContent"
                    role="tabpanel"
                    aria-labelledby="advancedTab"
                  >
                    <h5 className="mb-3 text-body-highlight">
                      Datos complementarios
                    </h5>
                    <div className="row g-3">
                      <label
                        className="form-check-label text-body fs-9"
                        htmlFor="fragileCheck"
                      >
                        Clasificación de producto
                      </label>
                      <Select
                        className="mb-1 mi-select"
                        classNamePrefix="rs"   
                        placeholder="Selecciona un tipo"
                        styles={customStyles_v2}
                        options={TPServicio}
                        value={TPServicio.find((option) => option.value === form1.watch("idTPServicio")) || null}
                        {...form1.register("idTPServicio", {
                            required: {
                            value: true,
                            message: "Este campo es obligatorio",
                            },
                        })}
                        onChange={(event) => {form1.setValue("idTPServicio",event.value)}}
                      />
                      <label
                        className="form-check-label text-body fs-9"
                        htmlFor="fragileCheck"
                      >
                        Ciclo de consumo
                      </label>
                      <input
                        className="form-control rounded-4 border-0 shadow-sm"
                        type="number"
                        placeholder="0.0"
                        style={{ maxWidth: "350px" }}
                        step="any"
                        {...form1.register("cicloConsumo")}
                      />
                      <div className="col-12 col-lg-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            id="fragileCheck"
                            type="checkbox"
                            {...form1.register("kardex")}
                          />
                          <label
                            className="form-check-label text-body fs-8"
                            htmlFor="fragileCheck"
                          >
                            Kardex
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-4">
            <div className="row g-2">
              <div className="col-12 col-xl-12">
                <div className="card mb-3 rounded-4 border-0 shadow-sm">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Organización</h4>
                    <div className="row gx-3">
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Categoria
                            </h5>
                            <NavLink className="fw-bold fs-9" to={"/main/Categorias"}>
                              Añadir nueva categoría
                            </NavLink>
                          </div>
                          <Select 
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona una categoria"
                            options={categoria}
                            styles={customStyles}
                            value={categoria.find((option) => option.value === form1.watch("idCategoria")) || null}
                            {...form1.register("idCategoria", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event) => {
                              form1.setValue("idCategoria", event.value, { shouldValidate: true });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Medida
                            </h5>
                            <NavLink className="fw-bold fs-9" to={"/main/Medida"}>
                              Agregar nueva medida
                            </NavLink>
                          </div>
                          <Select
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona una medida"
                            options={medida}
                            styles={customStyles}
                            value={medida.find((option) => option.value === form1.watch("idMedida")) || null}
                            {...form1.register("idMedida", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event)=>{form1.setValue("idMedida",event.value)}}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-xl-12">
                <div className="card mb-3 rounded-4 border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex flex-wrap mb-4">
                      <h4 className="mb-0 text-body-highlight me-2">
                        Apariencia
                      </h4>
                      <NavLink className="fw-bold fs-8" to={"/main/Marca"}>
                        Ir a marcas
                      </NavLink>
                    </div>
                    <div className="row gx-3">
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Marca
                            </h5>
                          </div>
                          <Select
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona una marca"
                            styles={customStyles}
                            options={marca}
                            value={marca.find((option) => option.value === form1.watch("idMarca")) || null}
                            {...form1.register("idMarca", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event)=>{form1.setValue("idMarca",event.value)}}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Modelo
                            </h5>
                          </div>
                          <Select
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona una modelo"
                            styles={customStyles}
                            options={modelo}
                            value={modelo.find((option) => option.value === form1.watch("idModelo")) || null}
                            {...form1.register("idModelo", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event)=>{form1.setValue("idModelo",event.value)}}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-xl-12">
                <div className="card mb-3 rounded-4 border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex flex-wrap mb-4">
                      <h4 className="mb-0 text-body-highlight me-2">
                        Ubicación
                      </h4>
                      <NavLink className="fw-bold fs-8" to={"/main/AreaLocal"}>
                        Ir a ubicación
                      </NavLink>
                    </div>
                    <div className="row gx-3">
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Área
                            </h5>
                          </div>
                          <Select
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona una área"
                            styles={customStyles}
                            options={area}
                            value={area.find((option) => option.value === form1.watch("idArea")) || null}
                            {...form1.register("idArea", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event)=>{form1.setValue("idArea",event.value)}}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-12">
                        <div className="mb-4">
                          <div className="d-flex flex-wrap mb-2">
                            <h5 className="mb-0 text-body-highlight me-2">
                              Local
                            </h5>
                          </div>
                          <Select
                            className="mb-3 mi-select mi-select-bordered"
                            classNamePrefix="rs"
                            placeholder="Selecciona un local"
                            styles={customStyles}
                            options={local}
                            value={local.find((option) => option.value === form1.watch("idLocal")) || null}
                            {...form1.register("idLocal", {
                              required: {
                                value: true,
                                message: "Este campo es obligatorio",
                              },
                            })}
                            onChange={(event)=>{form1.setValue("idLocal",event.value)}}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}



